import { useForm } from "react-hook-form"
import { useResetPasswordRequest } from '../../services/Login';
import PasswordSetter from "../Common/PasswordSetter";
import { useTrads } from "../../contexts/trads/useTrads";
import { useEffect } from "react";
interface ResetPasswordData{
    token:string| null;
    password:string;
    password_verif:string;
}



function ResetPassword({token}:{token:string | null}){
    const { register,watch,handleSubmit,setError, formState: { errors }  } = useForm({
        defaultValues:{token:token,password:"",password_verif:""} as ResetPasswordData,
        shouldUseNativeValidation: true,
        mode:'onSubmit',
    });
    const {result,resetPasswordRequest}=useResetPasswordRequest();
    const  onSubmit =  (data:ResetPasswordData) => {
        resetPasswordRequest(data.token??"", data.password)
    }
    const {translate}=useTrads();
    const password=watch('password');
    const password_verif=watch('password_verif');
    useEffect(()=>{
        if(result.error) {
            const errors=result.error as Record<string,string>;
            
            for (const i in errors) {
                    // @ts-expect-error i est connu!
                    setError(i, {type:'validate',message: translate(errors[i])});  
            }
            if(!('token' in errors)) {
                result.error=null;
            }
            
        }
    },[setError,result,translate]);
    /* 
    TODO: validate password strength
    */

    return (
        
        result.isSuccess ? <p className="p-3 mb-2 bg-success text-white">{translate('reset_password_success')}</p> : (
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('reset_password_error')}</p> :
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('reset_password_loading')}</p> : (

            <form className="row align-items-center" onSubmit={(event) => void handleSubmit(onSubmit)(event)}>
                <div className="col-auto  mb-3">
                    <PasswordSetter
                        name="password"
                        label={translate('login_form_password')}
                        errors={errors}
                        registerOutput= {register("password", {
                            validate: (value) => {

                                if(password_verif && value !== password_verif){
                                    return translate('password_verif_mismatch');
                                }
                                //return validatePassword(value);
                                return true;
                                    
                            }
                        })} 
                        registerOutputValidation= {register("password_verif", {
                            validate: value => value === password || translate('password_verif_mismatch')
                        })}
                        rest={{"autoComplete" : "new-password"}}
                        restValidation={{"autoComplete" : "new-password"}}
                    />
                </div>
                <div className="col-auto  mb-3">
                    <button type="submit">{translate('form_submit')}</button>
                </div>
            </form>

            )
        )
    )
}
export default ResetPassword;